import { DecoderHelpers } from '@headless-workspace/utils';
import { z } from 'zod';
import { ImageDTO } from '../../../../../client';

export const PromoBannerDTO = z.object({
    type: z.union([DecoderHelpers.caseInsensitiveLiteral('gwp'), DecoderHelpers.caseInsensitiveLiteral('fidelity')]),
    id: z.string(),
    title: z.string().optional(),
    description: z.string().optional(),
    legalMention: z.string().optional(),
    image: ImageDTO,
    cta: z
        .object({
            link: z.string().optional(),
        })
        .optional(),
});

export type PromoBannerDTO = z.infer<typeof PromoBannerDTO>;
